import {Component, Inject, OnDestroy, OnInit} from '@angular/core';

import {
    AppAlertService,
    ParametersService,
    SettingsService,
    SettingsNotificationsService,
    SettingsNotificationsDefaultService,
    SubtitlesService,
} from "../../core";
import {AlarmType, Device, NotificationConfig} from "../../models";
import {DOCUMENT} from "@angular/common";
import {Subscription} from "rxjs";

@Component({
    selector: 'settings-notifications',
    templateUrl: './settings-notifications.component.html',
    styleUrls: ['./settings-notifications.component.scss']
})
export class SettingsNotificationsComponent implements OnInit, OnDestroy {
    deviceName: string = '';
    notificationConfig!: NotificationConfig;
    notificationConfigSub!: Subscription | undefined;
    selectedModuleSub: Subscription | undefined;
    isTurnedOnByToggleBtn: keyof NotificationConfig | ''= '';

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private appAlert: AppAlertService,
        public parameters: ParametersService,
        public settings: SettingsService,
        public settingsNotifications: SettingsNotificationsService,
        public settingsNotificationsDefault: SettingsNotificationsDefaultService,
        private subtitles: SubtitlesService,
    ) {
        const deviceElement = this.document.getElementById('device_name');
        if (deviceElement) {
            this.deviceName = deviceElement.innerHTML;
        }
    }

    ngOnInit() {
        if (this.settings.selectedModule) {
            this.settingsNotificationsDefault.getNotificationInformation(this.settings.selectedModule.udid);
        }
        this. notificationConfigSub = this.settingsNotificationsDefault.notificationConfig$.subscribe(config => {
            this.notificationConfig = config;
        });
        this.selectedModuleSub = this.settings.selectedModule$.subscribe(() => {
            this.settingsNotificationsDefault.getNotificationInformation(this.settings.selectedModule.udid);
        })
    }

    ngOnDestroy() {
        this.notificationConfigSub?.unsubscribe();
        this.selectedModuleSub?.unsubscribe();
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    openDialog(dialog: AlarmType | 'changeEmail' | ''): void {
        if (this.parameters.demoAccount()) {
            this.appAlert.openDemoAccountDialog();
            return;
        }
        this.settingsNotifications.showNotificationDialog = dialog;
    }

    openUpdateDialog(notificationType: keyof NotificationConfig): void {
        if (this.parameters.demoAccount()) {
            this.appAlert.openDemoAccountDialog();
            return;
        }
        this.settingsNotifications.setDialogTime(notificationType);
        switch (notificationType) {
            case 'error':
                this.openDialog('alarm');
                break;
            case 'warning':
                this.openDialog('warning');
                break;
            case 'info':
                this.openDialog('notification');
                break;
        }
    }

    closeDialog(): void {
        if (this.isTurnedOnByToggleBtn) {
            this.notificationConfig[this.isTurnedOnByToggleBtn].enable = false;
            this.isTurnedOnByToggleBtn = '';
        }
        this.settingsNotifications.showNotificationDialog = '';
    }

    getAlarmText(notificationType: keyof NotificationConfig): string {
        switch (notificationType) {
            case 'error':
                return this.settingsNotificationsDefault.notificationConfig.getValue().error.from.whole + ' - '
                    + this.settingsNotificationsDefault.notificationConfig.getValue().error.to.whole;
            case "warning":
                return this.settingsNotificationsDefault.notificationConfig.getValue().warning.from.whole + ' - '
                    + this.settingsNotificationsDefault.notificationConfig.getValue().warning.to.whole;
            case "info":
                return this.settingsNotificationsDefault.notificationConfig.getValue().info.from.whole + ' - '
                    + this.settingsNotificationsDefault.notificationConfig.getValue().info.to.whole;
        }
    }

    toggleNotification(notificationType: keyof NotificationConfig): void {
        if (this.parameters.demoAccount()) {
            this.appAlert.openDemoAccountDialog();
            return;
        }

        this.notificationConfig[notificationType].enable = !this.notificationConfig[notificationType].enable;

        if (this.notificationConfig[notificationType].enable) {
            this.settingsNotifications.setDialogTime(notificationType);
            this.settingsNotifications.time.enable = true;
            switch (notificationType) {
                case 'error':
                    this.isTurnedOnByToggleBtn = 'error';
                    this.openDialog('alarm');
                    break;
                case 'warning':
                    this.isTurnedOnByToggleBtn = 'warning';
                    this.openDialog('warning');
                    break;
                case 'info':
                    this.isTurnedOnByToggleBtn = 'info';
                    this.openDialog('notification');
                    break;
            }
        } else {
             this.settingsNotificationsDefault.notificationConfig.next(this.notificationConfig);
             const selectedUdid = this.settings.getSelectedUdid();
             this.settingsNotifications.setNotificationTime(selectedUdid, notificationType);
        }
    }

    showAlertDeleteDevice(device: Device): void {
        this.settingsNotifications.deviceToDelete = device;
        this.appAlert.openConfirmDialog({
            title: this.subtitle(5221),
            message: this.subtitle(5036) + " " + device.nazwa_urzadzenia + "?",
            okButtonText: this.subtitle(735),
            cancelButtonText: this.subtitle(442),
            okFunction: this.settingsNotifications.deleteDevice.bind(this.settingsNotifications),
            danger: true,
        });
    }

    showAlertRemoveAssignedAccount(id: string, name: string): void {
        let message = this.subtitles.setSubtitle(6835);
        const accountName = name ? ' ' + name : '';
        if (accountName) message += accountName + '?';
        this.settingsNotifications.accountToDelete = id;

        this.appAlert.openConfirmDialog({
            title: this.subtitle(5041),
            message,
            okButtonText: this.subtitle(735),
            cancelButtonText: this.subtitle(442),
            okFunction: this.settingsNotifications.removeAssignedAccount.bind(this.settingsNotifications),
            danger: true,
        });
    }
}
